/**
 * Calculates the dot product of two quat's
 *
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @returns {Number} dot product of a and b
 * @function
 */
module.exports = require('gl-vec4/dot')



//////////////////
// WEBPACK FOOTER
// ./~/gl-quat/dot.js
// module id = 394
// module chunks = 28901507966785 35783957827783